export default __webpack_public_path__ + "static/media/mountains.03d29b95.svg";